import tw from 'twin.macro'

export const Optional = tw.span`font-bahnschrift font-light text-[12px] leading-[14px] text-gray-500`
export const Percetage = tw.span` font-bahnschrift font-semibold text-[12px] leading-[14px] text-white`
